import { IMemberActionEvent, StatusMemberRegisterWaiting } from 'app/api/event/model'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import {
  ILocation
} from 'app/containers/EventManagement/layouts/CreateEvent/type'
import { useChangeStatusManyMemberRegister } from 'app/react-query/hook/event'
import { useAppSelector } from 'app/redux/hooks'
import { useRef } from 'react'

export const ModalApproveManyMember = ({
  locations,
  listMember,
}: {
  listMember?: IMemberActionEvent[]
  locations?: ILocation[]
}) => {
  const user = useAppSelector(state => state?.user)?.profile
  const refModal = useRef<IRefModal>({})
  const [form] = BaseForm.useForm<{ team: number; locationIds?: number[] }>()
  const { mutateAsync: mutateAsyncUpdate, isLoading } =
    useChangeStatusManyMemberRegister()

  const handleSubmit = async () => {
    if (!listMember?.length) return
    const res = await mutateAsyncUpdate(
      listMember?.map(team => ({
        status: StatusMemberRegisterWaiting.ACCEPTED,
        id: team.id,
        approvedById: +(user?.member?.id ?? 0),
        locationIds: locations?.map(itm => itm?.id ?? 0),
      })) ?? [],
    )

    if (res) {
      refModal?.current?.hide?.()
      window.location.reload()
    }
  }

  return (
    <BaseModalComponent
      ref={refModal}
      titleModal="Phê duyệt tất cả đăng ký"
      buttonOpenModal={
        <BaseButton
          children="Phê duyệt tất cả"
          onClick={() => refModal.current?.open?.()}
          type="text"
        />
      }
      handleSubmit={form?.submit}
      isLoadingConfirm={isLoading}
      renderContent={
        <BaseForm form={form} onFinish={handleSubmit}>
          <BaseSpace size={8}>
            <BaseText
              children={`Bạn có chắc chắn phê duyệt tất cả đơn đăng ký này?`}
              fontWeight="medium"
              fontSize="xs"
            />
            <BaseText
              children={`Lưu ý: Sau khi phê duyệt, bạn có thể thay đổi trạng thái của đoàn viên trong hoạt động`}
              colorText="statesOrangeColor"
              opacity="0.8"
            />
          </BaseSpace>
        </BaseForm>
      }
    />
  )
}
